import { render, staticRenderFns } from "./credit-applicants.vue?vue&type=template&id=a06c7ce6"
import script from "./credit-applicants.vue?vue&type=script&lang=js"
export * from "./credit-applicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports